<template>
  <div id="navBar" class="relative z-50">
    <nav class="flex items-center py-2 text-default">
      <div class="container px-4 mx-auto">
        <div class="flex items-center justify-between navbar-container">

          <!-- ANCHOR LOGO -->
          <div class="hidden lg:flex items-center">
            <router-link to="/"
                        class="flex items-center py-3 flex-no-shrink text-grey-darkest logo-container"
                        :style="hideLogo ? '' :  'visibility: hidden'"
                        title="Retourner à l'accueil">
              <img :src="logo" alt="CodeSnippet"/>
            </router-link>
          </div>

          <!-- ANCHOR LIENS DE NAVIGATION -->
          <div class="flex items-center">
            <div class="flex items-center">
              <a href="/#team" title="Découvrir les membres de l'équipe">
                <Button label="L'équipe" class="mx-2 p-button-link"/>
              </a>
              <router-link :to="{ name: 'Guide' }" title="Découvrir le guide d'utilisation">
                <Button label="Guide" class="mx-2 p-button-link"/>
              </router-link>

              <!-- Bouton LG -->
              <router-link
                :to="authenticated === true ? { name: 'Dashboard' } : { name: 'Authentication' }"
                title="Accéder à vos projets" class="hidden lg:flex">
                <Button
                  :label="authenticated === true ? 'Dashboard' : 'Se connecter'"
                  class="mx-2 p-button-rounded"
                />
              </router-link>

              <!-- Bouton Mobile -->
              <router-link class="mx-2 p-button-rounded small-btn flex lg:hidden"
                          :to="authenticated === true ? { name: 'Dashboard' } : { name: 'Authentication' }">
                <Button
                  class="mx-2"
                  :icon="authenticated === true ? 'mdi-home' : 'mdi-account'"
                  :icon-size="20"
                />
              </router-link>

            </div>

            <!-- Dark Mode -->
            <Button
              class="mx-2"
              @click="darkMode"
              v-tooltip="{ content: themeTooltip, placement: 'bottom' }"
              :icon="this.$store.state.dark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'"
              :icon-size="20"
            />
          </div>
        </div>
      </div>
    </nav>
  </div>

</template>

<script>
import logo from '~/assets/logo.png'
import { mapGetters } from 'vuex'

export default {
  name: 'BaseNavBar',
  data: () => ({
    logo: logo,
    isLogged: false,
  }),
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
    }),
    hideLogo() {
      return this.$route.path != '/'
    },
    themeTooltip() {
      if (this.$store.state.dark) return 'Activer le thème clair'
      else return 'Activer le thème sombre'
    }
  },
  methods: {
    darkMode() {
      const currentTheme = !this.$store.state.dark

      this.$store.commit('changeState', {
        key: 'dark',
        data: currentTheme,
      })
      this.$dark(currentTheme)
    },
  },
}
</script>

<style scoped>
.light-theme .logo-img {
  filter: invert(70%);
}
</style>
